import { musicVolume, useMusicVolume } from '../audio/music-volume';
import s from './ui.module.scss';

/** Le curseur de volume de la musique, dans la barre du haut. */
export function MusicVolume() {
  const volume = useMusicVolume();
  return (
    <label className={s.volume} title="Volume de la musique">
      <span className={s.volumeLabel}>Musique</span>
      <input
        type="range"
        className={s.volumeRange}
        min={0}
        max={100}
        step={1}
        value={Math.round(volume * 100)}
        onChange={(event) => musicVolume.set(Number(event.target.value) / 100)}
        aria-label="Volume de la musique"
      />
    </label>
  );
}
